import React, { useState } from 'react';
import {
    Box,
    Fab,
    Drawer,
    IconButton,
    AppBar,
    Toolbar,
    Typography,
} from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import CloseIcon from '@mui/icons-material/Close';
import FiltersPanel from './FiltersPanel';
import { themeColors } from '../../theme/colors';

const MobileFilters: React.FC = () => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>
            <Fab
                color="primary"
                sx={{
                    position: 'fixed',
                    bottom: 80,
                    right: 24,
                    display: { xs: 'flex', md: 'none' },
                    backgroundColor: themeColors['500'],
                    '&:hover': {
                        backgroundColor: themeColors['600'],
                    },
                }}
                onClick={handleOpen}
            >
                <FilterListIcon />
            </Fab>

            <Drawer
                anchor="left"
                open={open}
                onClose={handleClose}
                sx={{
                    display: { xs: 'block', md: 'none' },
                    '& .MuiDrawer-paper': {
                        width: '80%',
                        maxWidth: 360,
                        backgroundColor: '#fafbfc',
                    },
                }}
            >
                <AppBar position="sticky" elevation={0} sx={{
                    backgroundColor: 'rgba(255, 255, 255, 0.9)',
                    backdropFilter: 'blur(20px)',
                    borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
                }}>
                    <Toolbar>
                        <Typography variant="h6" sx={{ flexGrow: 1, color: themeColors['900'] }}>
                            Фильтры
                        </Typography>
                        <IconButton edge="end" onClick={handleClose} sx={{ color: themeColors['600'] }}>
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <Box sx={{ height: '100%', overflow: 'auto' }}>
                    <FiltersPanel />
                </Box>
            </Drawer>
        </>
    );
};

export default MobileFilters;